import { useEffect, useRef, useState } from "react";
import "./BrandLogo.css";

/**
 * Paylaşılan TERMINAL-EX marka logosu.
 * - Tüm uygulamada tutarlı görünüm: "TERMINAL" beyaz + "-EX" turuncu + cursor
 * - `loop` true ise (Landing/Login): typing animasyonu sürekli döner
 * - `loop` false ise (Layout/header): mount'ta 1 kez oynar, sonra statik kalır
 *
 * Eyebrow (üst küçük etiket) opsiyonel; default "Darkex Hedge".
 *
 * Tasarım Login.css'teki `dx-` ailesi ile birebir uyumlu — fontlar, renkler,
 * cursor yanıp sönmesi aynı tokenlardan beslenir.
 */
export default function BrandLogo({
  size = "md", // sm | md | lg
  loop = false,
  eyebrow = "Darkex Hedge",
  showEyebrow = true,
  align = "start", // start | center
  className = "",
}) {
  const [base, setBase] = useState(loop ? "" : "TERMINAL");
  const [ex, setEx] = useState(loop ? "" : "-EX");
  const [exOrange, setExOrange] = useState(!loop);
  const cancelledRef = useRef(false);

  useEffect(() => {
    cancelledRef.current = false;

    const T = {
      type: 95,
      del: 70,
      holdFull: 900,
      holdGap: 380,
      holdEnd: 2400,
    };
    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

    const playOnce = async () => {
      setBase("");
      setEx("");
      setExOrange(false);
      let t = "";
      for (const c of "TERMINAL") {
        if (cancelledRef.current) return;
        t += c;
        setBase(t);
        await sleep(T.type);
      }
      let e = "";
      for (const c of "-EX") {
        if (cancelledRef.current) return;
        e += c;
        setEx(e);
        setExOrange(false);
        await sleep(T.type);
      }
      await sleep(T.holdFull);
      for (let i = "-EX".length; i > 0; i--) {
        if (cancelledRef.current) return;
        setEx("-EX".slice(0, i - 1));
        await sleep(T.del);
      }
      await sleep(T.holdGap);
      e = "";
      for (const c of "-EX") {
        if (cancelledRef.current) return;
        e += c;
        setEx(e);
        setExOrange(true);
        await sleep(T.type);
      }
    };

    const run = async () => {
      await playOnce();
      if (!loop || cancelledRef.current) return;
      while (!cancelledRef.current) {
        await sleep(T.holdEnd);
        if (cancelledRef.current) return;
        await playOnce();
      }
    };
    run();
    return () => {
      cancelledRef.current = true;
    };
  }, [loop]);

  return (
    <div
      className={`bx-logo bx-${size} bx-align-${align} ${className}`}
      data-testid="brand-logo"
    >
      {showEyebrow && <div className="bx-eyebrow">{eyebrow}</div>}
      <div className="bx-name">
        {/* Görünmez genişlik tutucu: yazım animasyonu sırasında blok genişliği
            sabit kalır, eyebrow kaymaz */}
        <span className="bx-sizer" aria-hidden="true">
          TERMINAL-EX
        </span>
        <span className="bx-live">
          <span className="bx-base">{base}</span>
          <span className={exOrange ? "bx-ex-orange" : "bx-ex-white"}>
            {ex}
          </span>
          <span className="bx-caret" />
        </span>
      </div>
    </div>
  );
}
